export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/array.js
// module id = aOxl
// module chunks = 0